import create from 'zustand';

export const useSelectedUserStore = create((set) => ({
    selectedUser: null,
    setSelectedUser: (user) => set({selectedUser: user}),
    clearSelectedUser: () => set({
        selectedUser: {
            hapakId: '',
            forename: '',
            surname: '',
            email: '',
            companySite: '',
            receiveReports: false,
            employee: false,
            employed: false,
        }
    }),
}));
